module.exports = __webpack_public_path__ + "img/vote.2436fe5a.png";